<template>
  <a-modal title="温馨提示" class="contrast-module" :visible="visible" @ok="onCofrim" @cancel="handleCancel">
    <div class="contrast-box">
        <a-row v-for="(item,index) in contrast" :key="index" class="contrast-row">
            <a-col>
                <span>第{{ item.serialNumber }}行商品{{ item.productName }}，采购价（{{ item.price }}元/件）与上次该商品的采购价（{{ item.purchasePrice }}元/件）不同</span>
            </a-col>
        </a-row>
    </div>
  </a-modal>
</template>
<script>
export default {
  name: "contrastModule",
  components: {},
  data() {
    return {
      visible: false,
      type:null,
      contrast:[]
    };
  },
  methods: {
    open(contrast,type) {
      this.type = type
      this.contrast = contrast
      this.visible = true
    },
    handleCancel() {
      this.visible = false;
      this.$emit("btnHandleCancel",this.type);
    },
    onCofrim() {
      this.visible = false;
      this.$emit("btnContrastModule",this.type);
    },
    getHistoryPrice() {
 
    },
  },
  watch: {},
};
</script>
<style lang="scss">
.contrast-module {
  width: 750px !important;
  min-height: 375px !important;
  .contrast-box {
    .contrast-row {
        padding: 5px 36px;
    }
  }
  .ant-modal-body {
      padding-top: 0;
  }
  .ant-table-wrapper {
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
  .ant-modal-footer {
    padding: 0 0 30px 0;
  }
}
</style>
